import React from 'react'
import {connect} from 'react-redux'
import {Flex, Div} from '/app/src/component'
import style from './style.css'
import ConversationSelector from '/app/src/model/Conversation/selector'
import CustomerSelector from '/app/src/model/Customer/selector'
import EntrySelector from '/app/src/model/Entry/selector'
import EmployeeSelector from '/app/src/model/Employee/selector'


class NavBar extends React.Component {


    constructor(props){
        super(props);
        this.renderGroup = this.renderGroup.bind(this)
    }
    renderGroup(){

        return(
            <Flex center grow>
                <Flex basis='25%' hAlignContent='right'>
                    <img
                        src={'/images/GroupChannel_L@2x.png'}
                        width='50px'
                        height='50px'
                        alt='group'
                    />
                </Flex>
                <Flex column className={style.ConversationTitle} grow hAlignContent='center'>
                    <div className={style.ConversationName}>
                        Gruppkanal
                    </div>
                    <div className={style.ConversationWith}>
                        Konversation med alla medarbetare

                    </div>
                </Flex>
                <Flex basis='25%'/>
            </Flex>

        )
    }
    render(){
        if(this.props.group) return this.renderGroup();

        let sendImageUrl;
        if(this.props.send){
            sendImageUrl = '/images/Placeholder_Outgoing.png';
        }else{
            sendImageUrl = '/images/Placeholder_Incoming.png';
        }



        let imageBorder = '#888888';

        if(this.props.isOnline){
            imageBorder = '#8fef54';
        }
        return (
            <Flex hAlignContent='center' vAlignContent='center' grow>
                <Flex basis='25%' hAlignContent='right' position='relative'>
                    <Div
                        position='absolute'
                        border= {'3px solid ' + imageBorder}
                        borderRadius='50%'
                        width='50px'
                        height='50px'
                    ></Div>

                    <img
                        className={style.PreviewImage}
                        src={this.props.imageUrl}
                        width='50px'
                        height='50px'
                        alt='customer'
                    />
                </Flex>
                <Flex column className={style.ConversationTitle} grow hAlignContent='center'>
                    <div className={style.ConversationWith}>
                        Konversation med
                    </div>
                    <div className={style.ConversationName}>{this.props.name}</div>
                </Flex>
                <Flex column basis='25%' hAlignContent='left'>
                    <Flex>
                        <img
                            alt=''
                            src={sendImageUrl}
                            width='40'
                            height='40'
                        />
                    </Flex>
                    <Flex>
                    {this.props.entryDateCreated}
                    </Flex>
                </Flex>
            </Flex>
        )
    }
}


function mapStateToProps(state, ownProps){
    let userId = state.getIn(['user', 'login', 'id'])
    let room = ownProps.room;
    let conversation = ConversationSelector.getByRoom(state, room)
    let type = ConversationSelector.getType(conversation)

    if(type === 'unassigned' || type === 'assigned'){
        let customerId = ConversationSelector.getCustomerId(conversation)
        let customer = CustomerSelector.getById(state, customerId)
        let isOnline;

        if(customer){
            isOnline = customer.getIn(['info', 'payload', 'is_online']);
        }

        let entry = ConversationSelector.lastEntry(conversation);
        let entrySend = EntrySelector.creatorId(entry) === userId;
        let entryDateCreated = EntrySelector.detailsDateCreated(entry);

        let name = CustomerSelector.getName(customer)
        let status = ''
        let imageUrl = CustomerSelector.getImage(customer)
        return {
            imageUrl: imageUrl,
            name: name,
            status: status,
            entryDateCreated: entryDateCreated,
            send: entrySend,
            isOnline: isOnline
        }

    }else if(type === 'intern'){
        let participants = ConversationSelector.getParticipantsId(conversation)

        if(!participants){
            return {}
        }

        let coworkerId = participants.filter(participant => participant !== userId).get(0)
        let coworker = EmployeeSelector.getById(state, coworkerId)
        let isOnline = coworker.get('is_online');
        let name = coworker.get('name')
        let status = coworker.get('status')
        let imageUrl = EmployeeSelector.getImage(coworker)

        let entry = ConversationSelector.lastEntry(conversation)
        let entryDateCreated = EntrySelector.detailsDateCreated(entry)
        let entrySend = EntrySelector.creatorId(entry) === userId;

        return {
            group: participants.size > 2,
            imageUrl: imageUrl,
            name: name,
            status: status,
            entryDateCreated: entryDateCreated,
            send: entrySend,
            isOnline: isOnline
        }
    }
    return {}
}


export default connect(mapStateToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/Conversation/index.js